import apolloFetcher from 'apolloFetcher';
import { get } from 'lodash';

export const getSettingsByAdmin = async (userId, roleType) => {
  const query = `
    {
      adminGetAllSettings {
        status
        message
        settings {
          settingsName
          settingsValue {
            value
          }
        }
      }
    }
  `;

  try {
    const response = await apolloFetcher.fetchWithToken({ query });

    return get(response, "data.adminGetAllSettings");
  } catch (err) {
    return {
      status: 500,
      message: err.message || err,
    };
  }
};

export const updateSettingsByAdmin = async (settingName, settingsValue) => {
  const query = `
    mutation adminUpdateSettings(
      $settingName: String
      $settingsValue: Boolean!
    ) {
      adminUpdateSettings(
        settingName: $settingName
        settingsValue: $settingsValue
      ) {
        status
        message
      }
    }	
  `;

  const variables = {
    settingName: settingName,
    settingsValue: settingsValue,
  };

  try {
    const response = await apolloFetcher.fetchWithToken({ query, variables });

    return get(response, "data.adminUpdateSettings");
  } catch (err) {
    return {
      status: 500,
      message: err.message || err,
    };
  }
};